/**
 * Service for creating SD campaigns with products
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const SdProductCampaignAPI = {

    /**
     * Sube archivos CSV y logo, retorna productos procesados
     */
    uploadFiles: async function (ownProductsCSV, competitorCSV, logo) {
        const formData = new FormData();

        if (ownProductsCSV) {
            formData.append('ownProductsCSV', ownProductsCSV);
        }
        if (competitorCSV) {
            formData.append('competitorCSV', competitorCSV);
        }
        if (logo) {
            formData.append('logo', logo);
        }

        const response = await fetch(`${API_BASE_URL}/sd-product-campaigns/upload`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error uploading files');
        }

        return await response.json();
    },

    /**
     * Creates a full SD campaign
     */
    createCampaign: async function (options) {
        const formData = new FormData();

        formData.append('profileId', options.profileId);
        formData.append('campaignName', options.campaignName);
        formData.append('dailyBudget', options.dailyBudget);
        formData.append('headline', options.headline);
        formData.append('ownProducts', JSON.stringify(options.ownProducts));
        formData.append('competitorProducts', JSON.stringify(options.competitorProducts));

        if (options.startDate) formData.append('startDate', options.startDate);
        if (options.endDate) formData.append('endDate', options.endDate);
        if (options.tactic) formData.append('tactic', options.tactic);
        if (options.bidOptimization) formData.append('bidOptimization', options.bidOptimization);
        if (options.defaultBid) formData.append('defaultBid', options.defaultBid);
        if (options.state) formData.append('state', options.state);
        if (options.logo) formData.append('logo', options.logo);

        const response = await fetch(`${API_BASE_URL}/sd-product-campaigns/create`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error creating campaign');
        }

        return await response.json();
    },

    /**
     * Creates multiple SD campaigns from CSV
     */
    createBulkCampaigns: async function (options) {
        const formData = new FormData();

        formData.append('profileId', options.profileId);
        formData.append('headline', options.headline || '');
        formData.append('dailyBudget', options.dailyBudget || 10);
        formData.append('campaignPrefix', options.campaignPrefix || 'SD_Product');
        formData.append('createIndividualCampaigns', options.createIndividualCampaigns ? 'true' : 'false');

        if (options.ownProductsCSV) {
            formData.append('ownProductsCSV', options.ownProductsCSV);
        }
        if (options.competitorCSV) {
            formData.append('competitorCSV', options.competitorCSV);
        }
        if (options.logo) {
            formData.append('logo', options.logo);
        }

        const response = await fetch(`${API_BASE_URL}/sd-product-campaigns/create-bulk`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error creating campaigns');
        }

        return await response.json();
    },

    /**
     * Sube un asset (logo/imagen)
     */
    uploadAsset: async function (profileId, file, assetType = 'IMAGE', assetSubType = 'LOGO') {
        const formData = new FormData();
        formData.append('profileId', profileId);
        formData.append('file', file);
        formData.append('assetType', assetType);
        formData.append('assetSubType', assetSubType);

        const response = await fetch(`${API_BASE_URL}/sd-product-campaigns/upload-asset`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error uploading asset');
        }

        return await response.json();
    }
};

export default SdProductCampaignAPI;

